<template>
  <div id="app" class="mb-10">
    <header-navigation :search_visible="false" @search="search"></header-navigation>
    <banner v-if="false"></banner>
    <video-box></video-box>
    <div class="container mx-auto">
      <tags></tags>
      <video-index class="pt-4"></video-index>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'pinia'
import { useVideoStore } from './stores'
import HeaderNavigation from './components/header.vue'
import Banner from './components/banner.vue'
import Tags from './components/tags.vue'
import VideoBox from './components/video-box.vue'
import VideoIndex from './components/video-index.vue'

export default {
  methods: {
    search( v ) {
      // console.log( v )
    },
    ...mapActions(useVideoStore, ['fetchStartup'])
  },
  async mounted () {
    await this.fetchStartup()
  },
  components: {
    HeaderNavigation,
    Banner,
    Tags,
    VideoIndex,
    VideoBox
  }
}
</script>
